<template>
	<div class="hot-assets">
		<div class="hot-width">
			<img src="../assets/byhs/logo3.png" style="width: 114px; height: 33px" />
			<div class="assets-title">闲置卡片别压箱，寄售秒变‘小金库’！</div>
			<div class="assets-text">专业卡片寄售平台，轻松变现闲置收藏卡！安全高效，全程无忧，让每张卡发挥最大价值。</div>
			<div>
				<img src="../assets/login-account/Group 1659@2x.png" style="width: 173px" class="u-iamge" />
				<img src="../assets/login-account/Group 1660@2x.png" class="u-iamge" />
				<img src="../assets/login-account/Group 1661@2x.png" class="u-iamge" />
				<img src="../assets/login-account/Group 1662@2x.png" style="width: 137px" class="u-iamge" />
			</div>
<div class="login-title">客服时间:周一至周日 09:00-23:0&nbsp;&nbsp;·&nbsp;&nbsp;商务联系电话:400-696-5550&nbsp;&nbsp;·&nbsp;&nbsp;联系邮箱:dlbaiyuekeji@163.com&nbsp;&nbsp;·&nbsp;&nbsp;辽宁省大连高新技术产业园区火炬路3号纳米大厦</div>
			<div class="login-title"><span class="login-grount" @click="Jumsp">ICP证:辽ICP备2024045765号-1&nbsp;&nbsp;</span> 增值电信ICP证编号:辽B2-20250003&nbsp;&nbsp;<!-- 辽公网安备21021102001650号 --></div>
			<!-- 暂时屏蔽 -->
			<!-- <div class="row-flex">
				<div class="row-title">
					<img src="../assets/login-account/6d2b20722cf422daa96afc438d729d5a 1@2x.png" style="width: 104px; height: 104px" />
					<div class="flex-title">微信小程序</div>
				</div>
				<div class="row-flex" style="margin-left: 20px;">
					<div class="row-title">
						<img src="@/assets/HomeView/bitHovieat.jpg" style="width: 104px; height: 104px" />
						<div class="flex-title">安卓App下载</div>
					</div>
				</div>
				<div class="row-flex" style="margin-left: 20px;">
					<div class="row-title">
						<img src="@/assets/HomeView/bitHovieat.jpg" style="width: 104px; height: 104px" />
						<div class="flex-title">苹果App下载</div>
					</div>
				</div>
				<div class="row-flex" style="margin-left: 20px;">
					<div class="row-title">
						<img src="@/assets/official-account/Group 1869@2x.png" style="width: 104px; height: 104px" />
						<div class="flex-title">商务合作请扫码</div>
					</div>
				</div>
			</div> -->
		</div>
	</div>
</template>

<script setup>
const Jumsp = () => {
	window.open('https://beian.miit.gov.cn');
};
</script>

<style lang="scss" scoped>
.hot-assets {
	margin-top: 30px;
	width: 100%;
	height: 516px;
	background: #ec3925;
	border-radius: 0px 0px 0px 0px;
	padding-top: 42px;
	position: relative;
	bottom: 0;
}

.hot-width {
	margin: auto;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	margin-top: 47rpx;
}

.assets-title {
	font-family: PingFang SC, PingFang SC;
	font-weight: 600;
	font-size: 16px;
	color: #ffffff;
	font-style: normal;
	text-transform: none;
	margin-top: 15px;
}

.assets-text {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #ffffff;
	font-style: normal;
	text-transform: none;
	margin-top: 8px;
}

.u-iamge {
	width: 157px;
	height: 54px;
	margin-top: 16px;
	margin-left: 11px;
}
.login-title {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #ffffff;
	font-style: normal;
	text-transform: none;
	margin-top: 20px;
}
.row-flex {
	display: flex;
}
.row-title {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 35px;
}
.flex-title {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #FFFFFF;
	margin-top: 9px;
	font-style: normal;
	text-transform: none;
}

.login-grount:hover{
	cursor: pointer;
}
</style>
